import React from 'react';
import CardItem from 'slickpay/online/CardItem.component';

import IMG_DEPOSIT from 'assets/slickpay-splash/deposit.png';
import IMG_NO_SHOW from 'assets/slickpay-splash/no_show.png';
import IMG_PROTECTION from 'assets/slickpay-splash/protection.png';
import { useTranslation } from 'providers/GILT.provider';

import CN from './ThreeCards.module.scss';

const LINK_PROTECTION = 'https://help.getslick.com/en/articles/4893453-all-about-deposits';
const LINK_DEPOSIT = 'https://help.getslick.com/en/articles/8645675-how-to-request-a-deposit-from-a-client';
const LINK_NO_SHOW = 'https://help.getslick.com/en/articles/4924817-no-show-protection-for-online-bookings';

const ThreeCards = () => {
  const { t } = useTranslation();
  return (
    <div data-bem="ThreeCards" className={CN.space}>
      <div className={CN.header}>
        <div className={CN.title}>{t('slickPay.onlinePayments.title')}</div>
      </div>
      <div className={CN.container} data-bem="ThreeCards__container">
        <CardItem
          imageSrc={IMG_PROTECTION}
          title={t('slickPay.onlinePayments.protectionTitle')}
          link={LINK_PROTECTION}
        />
        <div className={CN.middleCard}>
          <CardItem imageSrc={IMG_DEPOSIT} title={t('slickPay.onlinePayments.depositTitle')} link={LINK_DEPOSIT} />
        </div>

        <CardItem imageSrc={IMG_NO_SHOW} title={t('slickPay.onlinePayments.noShowTitle')} link={LINK_NO_SHOW} />
      </div>
    </div>
  );
};
export default ThreeCards;
